import Form from 'mlmi-library/components/form/v1/form'
import 'mlmi-library/plugins/scroll-to'
import { TRANSITION_END } from 'mlmi-library/utils/animation'

const localeSettings = {
  style: 'currency',
  currency: 'CAD',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}

$.fn.FormAdhesion_Part1 = function(steps) {
  let self = this
  self.form = undefined

  self.handle_success = function(response) {
    steps.setFormID(response.form_id)
    steps.nextStep()
    if ('payment' in response) {
      steps.initializeStripe(response.payment)
    }
  }

  self.initialize_form = function() {
    self.form = new Form('.adhesion-form__part-1', {
      ajax_redirect: false,
      ajax_url: culturemontreal_l10n.ajax_url,
      auto_scroll: true,
      onSuccess: self.handle_success,
    })
  }

  self.initialize_fields = function() {
    //
    const params = new URLSearchParams(window.location.search);
    const amount = params.get('amount'); // expects a plain number like ?amount=15

    if (amount) {
      const $radio = self.find('input[name="tarif"][value="' + amount + '"]');
      if ($radio.length) {
        $radio.prop('checked', true).trigger('change');
      }
    }

    // Remove the parameter from the URL
    params.delete('amount');
    const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', newUrl);
  }

  self.update_fields = function() {
    //
  }

  return function() {
    self.initialize_form()
    self.initialize_fields()
    return self
  }()
}

$.fn.FormAdhesion_Part2 = function(steps) {
  let self = this
  self.form = undefined

  self.handle_success = function(x) {
    if ('payment' in x) {
      steps.initializeStripe(x.payment)
    }
    steps.nextStep()
  }

  self.initialize_form = function() {
    self.form = new Form('.adhesion-form__part-2', {
      ajax_redirect: false,
      ajax_url: culturemontreal_l10n.ajax_url,
      auto_scroll: true,
      onSuccess: self.handle_success,
    })
  }

  self.initialize_fields = function() {
    self.find('select[name="province"]').on('change', function() {
      if ($(this).val() == 'Hors Canada') {
        self.find('input[name="pays"]').val('')
        $('.field-container--pays').addClass('visible')
      } else {
        self.find('input[name="pays"]').val('Canada')
        $('.field-container--pays').removeClass('visible')
      }
    })
    // if (location.hostname == 'localhost' || location.hostname == 'dev.culturemontreal.ca') {
    //   self.find('input[name="prenom"]').val('Testeur')
    //   self.find('input[name="nom"]').val('Nouveaucompte')
    //   self.find('input[name="phone"]').val('514-625-4815')
    //   self.find('input[name="email"]').val('mlajeunesse+' + Math.ceil(Math.random() * 9999) + '@gmail.com')
    //   self.find('input[name="adresse"]').val('927, rue Montaigne')
    //   self.find('input[name="ville"]').val('Deux-Montagnes')
    //   self.find('input[name="code_postal"]').val('J7R 6S2')
    //   self.find('input[name="password"]').val('password')
    //   self.find('input[name="password_confirm"]').val('password')
    // }
  }

  self.update_fields = function() {
    //
  }

  return function() {
    self.initialize_form()
    self.initialize_fields()
    return self
  }()
}

$.fn.FormAdhesion_Part3 = function(steps) {
  let self = this
  self.form = undefined

  self.handle_success = function(x) {
    if ('payment' in x) {
      steps.initializeStripe(x.payment)
    }
    steps.nextStep()
  }

  self.initialize_form = function() {
    self.form = new Form('.adhesion-form__part-3', {
      ajax_redirect: false,
      ajax_url: culturemontreal_l10n.ajax_url,
      auto_scroll: true,
      onSuccess: self.handle_success,
    })
  }

  self.initialize_fields = function() {
    self.find('select[name="activite_secteur"]').on('change', function() {
      if ($(this).val() == 44) {
        $('.field-container--discipline').addClass('visible')
      } else {
        $('.field-container--discipline').removeClass('visible')
      }
    })
  }

  self.update_fields = function() {
    //
  }

  return function() {
    self.initialize_form()
    self.initialize_fields()
    return self
  }()
}

$.fn.FormAdhesion_Part4 = function(steps) {
  let self = this
  self.form = undefined
  self.stripe_form = undefined

  self.handle_success = function(x) {
    location.href = x.redirect
  }

  self.initialize_form = function() {
    self.form = new Form('.adhesion-form__part-4', {
      ajax_redirect: false,
      ajax_url: culturemontreal_l10n.ajax_url,
      auto_scroll: true,
      onSuccess: self.handle_success,
    })
  }

  self.initialize_fields = function() {
    $('.adhesion-details__back-link').on('click', function() {
      steps.switchTo(parseInt($(this).data('step'), 10))
      return false
    })

    self.find('input[name="methode_paiement"]').on('change', function() {
      if ($(this).val() == 'cheque') {
        $('.adhesion-form__part-4 .submit-container').css('display', '')
        $('#stripe-payment-form').hide()
      } else if ($(this).val() == 'credit') {
        $('.adhesion-form__part-4 .submit-container').css('display', 'none')
        $('#stripe-payment-form').show()
      }
    }).trigger('change')
  }

  self.update_fields = function() {
    /* Step 1 values */
    let form_step1 = steps.forms.step_1.form.form,
    tarif = form_step1.get_form_value('tarif')
    if (tarif == 'offerte') {
      tarif = 0
      self.find('.adhesion-details__item--amount').hide()
      self.find('.adhesion-details__item--other').show().text('Merci de vérifier vos informations avant de soumettre votre adhésion.')
    } else {
      tarif = parseFloat(tarif.replaceAll(',', '.').replaceAll(' ', '').replaceAll(' ', ''))

      self.find('.adhesion-details__item--amount').show()
      self.find('.adhesion-details__cell--adhesion').text(tarif.toLocaleString('fr-CA', localeSettings).replace('CA', '').trim())
      self.find('.adhesion-details__item--other').hide()
    }

    /* Set payment total */
    let total = tarif // + donation_amount
    if (total > 0) {
      $('.adhesion-details__element--total').show()
    } else {
      $('.adhesion-details__element--total').hide()
    }
    self.find('.adhesion-details__cell--total').text(total.toLocaleString('fr-CA', localeSettings).replace('CA', '').trim())

    /* Step 2 values */
    let form_step2 = steps.forms.step_2.form.form
    $('.adhesion-details__cell--full-name').text(form_step2.get_form_value('prenom') + ' ' + form_step2.get_form_value('nom'))
    $('.adhesion-details__cell--address-1').text(form_step2.get_form_value('adresse'))
    $('.adhesion-details__cell--address-2').text(form_step2.get_form_value('adresse_2'))
    if (form_step2.get_form_value('adresse_2')) {
      $('.adhesion-details__item--address-2').show()
    } else {
      $('.adhesion-details__item--address-2').hide()
    }
    $('.adhesion-details__cell--city').text(form_step2.get_form_value('ville'))
    let province = form_step2.get_form_value('province'),
    country = form_step2.get_form_value('pays')
    if (province == 'Hors Canada') {
      $('.adhesion-details__cell--province').text('')
      $('.adhesion-details__item--province').hide()
      $('.adhesion-details__cell--country').text(form_step2.get_form_value('pays').toUpperCase())
      $('.adhesion-details__item--country').show()
    } else {
      $('.adhesion-details__cell--province').text(form_step2.get_form_value('province'))
      $('.adhesion-details__item--province').show()
      $('.adhesion-details__cell--country').text('')
      $('.adhesion-details__item--country').hide()
    }
    $('.adhesion-details__cell--postal-code').text(form_step2.get_form_value('code_postal'))
    $('.adhesion-details__cell--phone').text(form_step2.get_form_value('phone'))
    $('.adhesion-details__cell--email').text(form_step2.get_form_value('email'))

    /* No payment */
    if (total == 0 || !total) {
      $('.field-container--methode_paiement').hide()
      $('input[name="methode_paiement"][value="cheque"]').prop('checked', true).change()
      self.find('.field__submit').text("Soumettre")
    } else {
      $('.field-container--methode_paiement').show()
      $('input[name="methode_paiement"][value="credit"]').prop('checked', true).change()
      self.find('.field__submit').text("Payer par chèque")
    }
  }

  return function() {
    self.initialize_form()
    self.initialize_fields()
    return self
  }()
}

export default {
  current: 1,
  forms: {
    step_1: undefined,
    step_2: undefined,
    step_3: undefined,
    step_4: undefined,
  },

  init() {
    let steps = this

    $('.form-steps__item').on('click', function() {
      steps.switchTo($(this).data('index'))
    })

    $('.adhesion-form__part-1').each(function() {
      steps.forms.step_1 = $(this).FormAdhesion_Part1(steps)
    })

    $('.adhesion-form__part-2').each(function() {
      steps.forms.step_2 = $(this).FormAdhesion_Part2(steps)
    })

    $('.adhesion-form__part-3').each(function() {
      steps.forms.step_3 = $(this).FormAdhesion_Part3(steps)
    })

    $('.adhesion-form__part-4').each(function() {
      steps.forms.step_4 = $(this).FormAdhesion_Part4(steps)
    })

    $('.adhesion-form__step--2, .adhesion-form__step--3, .adhesion-form__step--4').hide()
  },

  switchTo(step) {
    let steps = this
    $('.form-steps').attr('data-current-step', step)
    $('.form-steps__item').attr('aria-selected', 'false')
    $('.form-steps__item[data-index="' + step + '"]').attr('aria-selected', 'true')
    $('html, body').scrollTo(0, 350, 4, 'easeInOutQuart')
    $('.adhesion-form__step--' + steps.current).attr('aria-hidden', 'true').one(TRANSITION_END, function() {
      $('.adhesion-form__step--' + steps.current).off(TRANSITION_END)
      $('.adhesion-form__step--' + steps.current).hide()
      steps.forms['step_' + step].form.form.enable_fields()
      steps.forms['step_' + step].update_fields()
      $('.adhesion-form__step--' + step).show()
      requestAnimationFrame(function() {
        $('.adhesion-form__step--' + step).attr('aria-hidden', 'false')
        steps.current = step
      })
    })
  },

  nextStep() {
    let steps = this, step = steps.current, hasStep = false
    while (!hasStep) {
      step += 1
      if ($('.adhesion-form__step--' + step).length) {
        hasStep = true
      }
    }
    steps.switchTo(step)
  },

  initializeStripe(client_secret) {
    const stripe = Stripe(culturemontreal_l10n.stripe_pk)
    const options = {
      clientSecret: client_secret,
      appearance: {
        theme: 'flat',
        variables: {
          colorDanger: '#ef0000',
          fontFamily: '"PxGroteskLight", system-ui, sans-serif',
        },
      },
      locale: 'fr',
    };

    self.stripe_form = $('#stripe-payment-form')

    const elements = stripe.elements(options),
    paymentElement = elements.create('payment')
    paymentElement.mount('#payment-element')
    const form = self.stripe_form.get(0)
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const {error} = await stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: culturemontreal_l10n.adhesion_url + '?st=Completed',
        },
      });

      if (error) {
        const messageContainer = document.querySelector('#stripe-error-message');
        messageContainer.textContent = error.message;
      }
    });
  },

  setFormID(form_id) {
    $('.adhesion-form__part-1, .adhesion-form__part-2, .adhesion-form__part-3, .adhesion-form__part-4').find('input[name="form_id"]').val(form_id)
  },
}
